// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".country-switcher-modal .text-light{color:#989998;font-weight:400;font-size:15px}.country-switcher-modal .mt{margin-top:15px}.country-switcher-modal__header-description{color:#999c9f;font-size:18px;letter-spacing:.3px;line-height:26px}.country-switcher-modal-content{padding:0 35px 35px}.country-switcher-modal-content .mb{margin-bottom:15px}", ""]);
// Exports
module.exports = exports;
